import { from } from '@apollo/client/link/core'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { sha256 } from 'crypto-hash'
import { setContext } from '@apollo/client/link/context'

export default defineNuxtPlugin(() => {
  const { public: config } = useRuntimeConfig()
  const { client } = useApolloClient('default')
  client.setLink(from([
    createPersistedQueryLink({
      sha256,
      useGETForHashedQueries: true,
    }),
    setContext(() => {
      return {
        uri: config.graphqlEndpoint.concat('?s=' + config.storeHeader),
      }
    }),
    client.link,
  ]))
})
